/* Tilbodssida – legg ruta <Route path="/tilbud" element={<MediabilityProposalPage />} /> i App.js.
   Norsk er standard; ?lang=en gir engelsk. */
import { useSearchParams } from "react-router-dom";
import { MEDIABILITY } from "../data/tilbod/mediability";
import { MEDIABILITY_NO } from "../data/tilbod/mediabilityNo";
import { ProductProposal } from "../components/proposal/ProductProposal";
import "../proposal.css";

const LANGS = [["no", MEDIABILITY_NO, "Norsk"], ["en", MEDIABILITY, "English"]];

export default function MediabilityProposalPage() {
  const [params, setParams] = useSearchParams();
  const want = params.get("lang");
  const pick = LANGS.find(([code]) => code === want) || LANGS[0];
  const d = {
    ...pick[1],
    langToggle: {
      current: pick[0],
      options: LANGS.map(([code, , label]) => [code, label]),
      set: (code) => setParams(code === LANGS[0][0] ? {} : { lang: code }, { replace: true }),
    },
  };
  return <ProductProposal d={d} />;
}
